import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const NoticeStateNewJersey = forwardRef(({ data, company, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-2xl">
            <div ref={refToPrint} className="space-y-6 text-gray-900 text-base leading-relaxed w-full">
                <h2 className="text-2xl font-bold">
                    NOTICE REGARDING INVESTIGATIVE CONSUMER REPORTS PER NEW JERSEY LAW
                </h2>

                <p>
                    With your permission, {company?.name}, the "Company," may order from a third-party consumer reporting agency
                    an investigative consumer report, which commonly includes information regarding your character, general reputation,
                    personal characteristics or mode of living and which involves obtaining information through personal interviews.
                    The precise nature and scope of any investigative consumer report requested by the Company will be as follows:
                    investigating the information contained in your employment application and other claims provided by you during
                    the interview and selection process, reviewing court and other public records relating to you, and interviewing people
                    who are knowledgeable about you.
                </p>

                <p>
                    The source of any investigative consumer report will be{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        VerifiedID
                    </a>
                    ,{" "}
                    <a href="tel:+18887182597" className="text-blue-600 underline">
                        (888) 718-2597
                    </a>
                    , 11180 State Bridge Road, suite 303, Alpharetta, GA, 30022, USA,{" "}
                    <a
                        href="https://verifiedid.co"
                        className="text-blue-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://verifiedid.co
                    </a>
                    .
                </p>
            </div>
        </div>
    )

})

export default NoticeStateNewJersey
